export const taskcreateConstants ={
    ADDTASK_RQUEST:"ADDINGTASK_REQUEST",
    ADDTASK_SUCCESS:"ADDINGTASK_SUCCESS",
    ADDTASK_ERROR:"ADDINGTASK_ERROR",

    QUESTION_REQUEST:"GET_QUESTION_REQUEST",
    QUESTION_SUCCESS:"GET_QUESTION_SUCCESS",
    QUESTION_ERROR:"GET_QUESTION_ERROR"
}